import { AlertProps, Alert as MUIAlert, styled } from "@mui/material";

const StyledAlert = styled(MUIAlert)(({ theme: { palette } }) => ({
  "&.MuiAlert-root": {
    fontSize: "0.75rem",
    fontWeight: "500",
    letterSpacing: "-0.24px",
    padding: "0rem 0.75rem",
  },
  "&.MuiAlert-standardInfo": {
    color: palette.theme?.secondary[900],
    backgroundColor: palette.theme?.secondary[200],
  },
  "&.MuiAlert-standardSuccess": {
    color: palette.theme?.primary[900],
    backgroundColor: palette.theme?.primary[100],
  },
  "&.MuiAlert-standardError": {
    color: palette.theme?.tertiary6[900],
    backgroundColor: palette.theme?.tertiary6[100],
    "& .MuiAlert-icon" : {
      color: palette.theme?.tertiary6[900],
    }
  },

  ".MuiAlert-action": {
    svg: {
      fontSize: "1rem",
    },
  },
}));

const Alert = (props: AlertProps) => {
  const { children, icon = false, ...rest } = props;

  return (
    <StyledAlert icon={icon} {...rest}>
      {children}
    </StyledAlert>
  );
};

export { Alert };
export default Alert;
